export default __webpack_public_path__ + "static/media/img-9.f97f588f.jpg";